import { render, staticRenderFns } from "./TheProductCustomizerComplementVisualizer.vue?vue&type=template&id=8ea693b8&"
import script from "./TheProductCustomizerComplementVisualizer.vue?vue&type=script&lang=js&"
export * from "./TheProductCustomizerComplementVisualizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ea693b8')) {
      api.createRecord('8ea693b8', component.options)
    } else {
      api.reload('8ea693b8', component.options)
    }
    module.hot.accept("./TheProductCustomizerComplementVisualizer.vue?vue&type=template&id=8ea693b8&", function () {
      api.rerender('8ea693b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/customizer/TheProductCustomizerComplementVisualizer.vue"
export default component.exports